module.exports = __webpack_public_path__ + "img/21.93fde607.jpg";